export default __webpack_public_path__ + "static/media/icon_recycle.cc195c95.svg";